import React from 'react';
import { FormattedMessage } from 'react-intl';
import { compose } from 'ramda';
import { withHandlers } from 'recompose';
import PropTypes from 'prop-types';

import Button from 'app/components/Button/Button';
import { HOME_URL } from 'app/router/constants/externalUrls';
import { homeSelected } from 'app/features/header/actions';
import { HEADER_RIGHT } from 'app/analytics/constants/positions';
import translations from 'app/features/localization/translations.json';
import connect from 'app/libs/connect';

const UI = ({ onClick }) => (
  <Button
    to={HOME_URL}
    type="five"
    onClick={onClick}
    testId="header-up-explore"
  >
    <FormattedMessage id="buttons_explore" />
  </Button>
);

UI.propTypes = {
  onClick: PropTypes.func.isRequired,
};

UI.displayName = 'ExploreButton';

const onClick =
  ({ homeSelected }) =>
  () => {
    homeSelected({
      position: HEADER_RIGHT,
      textOfButtonOrLink: translations.buttons_explore,
    });
  };

const ExploreButton = compose(
  connect(null, { homeSelected }),
  withHandlers({ onClick }),
)(UI);

export default ExploreButton;
